import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ProjectState} from './project.reducer';
export const selectProjectState = createFeatureSelector<ProjectState>('projects');

export const selectAllProjects = createSelector(
  selectProjectState,
  (state) => state.projects
);

export const selectAllExploreProjects = createSelector(
  selectProjectState,
  (state) => state.exploreProjects
);

export const selectSelectedProject = createSelector(
  selectProjectState,
  (state) => state.selectedProject
);

export const selectProjectById = (projectId: number) => createSelector(
  selectProjectState,
  (state) => {
    const project = state.projects.find(p => p.id === projectId);
    if (project) {
      return project;
    }
    if (state.selectedProject && state.selectedProject.id === projectId) {
      return state.selectedProject;
    }
    return null;
  }
);

export const selectProjectNameById = (projectId: number) => createSelector(
  selectProjectState,
  (state) => {
    const project = state.projects.find(p => p.id === projectId);
    if (project) {
      return project.name;
    }
    if (state.selectedProject && state.selectedProject.id === projectId) {
      return state.selectedProject.name;
    }
    return null;
  }
);

export const selectLoading = createSelector(
  selectProjectState,
  (state) => state.loading
);

export const selectError = createSelector(
  selectProjectState,
  (state) => state.error
);
